"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripHtml = void 0;
const stripHtml = (originalStr, allowed = "<b><i><br><br/><strong><ul><ol><li>") => {
    allowed = (((allowed || "") + "").toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');
    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
    return originalStr.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
        return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
    });
};
exports.stripHtml = stripHtml;
//# sourceMappingURL=html.js.map